import { render, staticRenderFns } from "./ModalProdutoDetalhes.vue?vue&type=template&id=aed4a910&scoped=true&"
import script from "./ModalProdutoDetalhes.vue?vue&type=script&lang=js&"
export * from "./ModalProdutoDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ModalProdutoDetalhes.vue?vue&type=style&index=0&id=aed4a910&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed4a910",
  null
  
)

export default component.exports